import React from 'react'

const Loading = () => <div />

export default Loading
